import { CallToAction } from 'components/CallToAction'
import { GatsbyImage } from 'gatsby-plugin-image'
import { heading, section } from '../classes'
import {prepareData} from 'utils/googleData'
import React from 'react';
const levels = [
	{
		title: 'The Company Level, Top Level Company-Wide OKRs',
		description:
			'This is the person responsible for spearheading the adoption of the OKR framework within an organization, communicating its value, and driving progress from the top.',
	},
	{
		title: 'The Department OKRs',
		description:
			'These high-level goals can then be broken down and assigned to departments. For example, the fourth key result to build a solid lead generation engine might then appear as a department-level objective for the marketing department.',
	},
	{
		title: 'The Team Level, Individual Employee OKRs',
		description:
			'These are the individuals leading teams -- from C-level executives and senior leadership to directors and department managers -- that generally own Objectives and goals for the company.',
	},
	{
		title: 'The Individual  OKRs',
		description:
			'These are individual employees within a company; sometimes they have direct ownership of Key Results, other times they are simply observers to organization goals.',
	},
]
export function Levels(props) {
    const {enable,title,subtitle,description,homeMarketsTitle,cta,markets,direction,text,style,gatsbyImage,sections,gatsbyImage2}= prepareData({props})
        if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
    return <></>
  }
    return (
        <section dir={direction} className={section()}>

<div className="mx-[10px] md:p-[16px] p-[24px] items-center ">
<div
   className="flex flex-col items-center text-center gap-[20px]"
    style={{ maxWidth: '1300px' }}
>
    <h2 className="text-[#00244d] text-[40px] leading-[1.5] mb-[28px] sm:max-w-[490px] font-light">
        OKR <br />
        Levels
    </h2>

    <p
        className="max-w-[640px] text-[20px] text-[#18171c] opacity-80"
        style={{ margin: '0 0 16px' }}
    >
        There are four levels in each organization.
        Everyone can see their OKRs and get inspired by
        what others are doing. You can set your personal
        OKRs and align your objectives with the overall
        goals of the company.
    </p>

    <div className="grid sm:grid-cols-1 gap-[32px] md:grid-cols-2">
        {levels.map((level, index) => (
            <div
            className="flex gap-[16px]"
                key={index}
            >
                <div className="text-[#00536b] text-[24px]">
                    0{index + 1}/
                </div>

                <div className="level-item-content">
                    <div className="text-[28px] text-[#00244d] mb-[12px]">
                        {level.title}
                    </div>
                    <div className="text-[18px]">
                        {level.description}
                    </div>
                </div>
            </div>
        ))}
    </div>
</div>
</div>
</section>
    )
}
